"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _classnames = _interopRequireDefault(require("classnames"));
var _filter = _interopRequireDefault(require("./filter.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterDate = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterDate, _React$Component);
  function FilterDate() {
    var _this;
    _classCallCheck(this, FilterDate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterDate, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_handleChangeStartDate", function (date) {
      var _this$_getDates = _this._getDates(),
        _this$_getDates2 = _slicedToArray(_this$_getDates, 2),
        endDate = _this$_getDates2[1];
      _this.props.onFilterChange(_this.props.column, [(0, _format["default"])(date, 'YYYY-MM-DD'), endDate]);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleChangeEndDate", function (date) {
      var _this$_getDates3 = _this._getDates(),
        _this$_getDates4 = _slicedToArray(_this$_getDates3, 1),
        startDate = _this$_getDates4[0];
      _this.props.onFilterChange(_this.props.column, [startDate, (0, _format["default"])(date, 'YYYY-MM-DD')]);
    });
    _defineProperty(_assertThisInitialized(_this), "_getDates", function () {
      var _ref = typeof _this.props.value !== 'undefined' ? _this.props.value : [],
        _ref2 = _slicedToArray(_ref, 2),
        startDate = _ref2[0],
        endDate = _ref2[1];
      if (startDate === '') {
        startDate = null;
      }
      if (endDate === '') {
        endDate = null;
      }
      return [startDate, endDate];
    });
    _defineProperty(_assertThisInitialized(_this), "_clearStartDate", function () {
      var _this$_getDates5 = _this._getDates(),
        _this$_getDates6 = _slicedToArray(_this$_getDates5, 2),
        endDate = _this$_getDates6[1];
      var newFilter = endDate ? [null, endDate] : '';
      _this.props.onFilterChange(_this.props.column, newFilter);
    });
    _defineProperty(_assertThisInitialized(_this), "_clearEndDate", function () {
      var _this$_getDates7 = _this._getDates(),
        _this$_getDates8 = _slicedToArray(_this$_getDates7, 1),
        startDate = _this$_getDates8[0];
      var newFilter = startDate ? [startDate, null] : '';
      _this.props.onFilterChange(_this.props.column, newFilter);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDateField", function (_ref3) {
      var date = _ref3.date,
        placeholder = _ref3.placeholder,
        onChange = _ref3.onChange,
        onClear = _ref3.onClear;
      var value = date || null;
      var cleanButton = value ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _filter["default"].cleanButton,
        onClick: onClear
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-remove text-warning"
      })) : null;
      var className = (0, _classnames["default"])([_filter["default"].filterBlock, _defineProperty({}, "".concat(_filter["default"].isFilter), value), {
        'has-warning': value
      }]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        className: "form-control input-sm",
        selected: value,
        onChange: onChange,
        placeholderText: placeholder,
        disabled: _this.props.disabled
      }), cleanButton);
    });
    return _this;
  }
  _createClass(FilterDate, [{
    key: "render",
    value: function render() {
      var _this$_getDates9 = this._getDates(),
        _this$_getDates10 = _slicedToArray(_this$_getDates9, 2),
        startDate = _this$_getDates10[0],
        endDate = _this$_getDates10[1];
      var startDatePicker = this._renderDateField({
        date: startDate,
        placeholder: 'from',
        onChange: this._handleChangeStartDate,
        onClear: this._clearStartDate
      });
      var endDatePicker = this._renderDateField({
        date: endDate,
        placeholder: 'to',
        onChange: this._handleChangeEndDate,
        onClear: this._clearEndDate
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _filter["default"].margin
      }, startDatePicker), endDatePicker);
    }
  }]);
  return FilterDate;
}(_react["default"].Component);
_defineProperty(FilterDate, "propTypes", {
  column: _propTypes["default"].string,
  value: _propTypes["default"].array,
  onFilterChange: _propTypes["default"].func,
  settings: _propTypes["default"].object,
  disabled: _propTypes["default"].bool
});